import React, { useState } from "react";
import Admin2 from "layouts/Admin2";
import WizardStepper from "./WizardStepper";
import PrepareStep from "./steps/PrepareStep";
import UploadStep from "./steps/UploadStep";
import CompleteStep from "./steps/CompleteStep";

const UploadBooksWizard = () => {
	const [step, setStep] = useState(1);
	const [downloadInfo, setDownloadInfo] = useState(null);

	const handleImportSuccess = (result) => {
		setDownloadInfo(result);
		setStep(3);
	};

	const handleImportMore = () => {
		if (downloadInfo?.downloadUrl) {
			window.URL.revokeObjectURL(downloadInfo.downloadUrl);
		}
		setDownloadInfo(null);
		setStep(1);
	};

	return (
		<Admin2>
			<div
				className="relative overflow-hidden"
				style={{ minHeight: "calc(100vh - 4rem)" }}
			>

				<div className="portal-import-workspace space-y-6">
					<div className="max-w-xl space-y-2">
						<p className="text-xs font-semibold uppercase tracking-widest text-akgreen">
							Publisher tools
						</p>
						<h1 className="text-2xl font-semibold tracking-tight text-akgreenest sm:text-3xl">
							Upload books
						</h1>
						<p className="text-sm leading-relaxed text-gray-600">
							Import book metadata from Excel or CSV. Covers and PDFs are
							attached separately via Bulk upload books.
						</p>
					</div>

					<div className="portal-list-panel overflow-hidden">
						<div className="border-b border-gray-100 bg-gray-50 px-5 py-5 sm:px-8">
							<WizardStepper current={step} />
						</div>

						<div className="px-5 py-6 sm:px-8 sm:py-8">
							{step === 1 ? (
								<PrepareStep onContinue={() => setStep(2)} />
							) : null}

							{step === 2 ? (
								<UploadStep
									onBack={() => setStep(1)}
									onSuccess={handleImportSuccess}
								/>
							) : null}

							{step === 3 ? (
								<CompleteStep
									downloadInfo={downloadInfo}
									onImportMore={handleImportMore}
								/>
							) : null}
						</div>
					</div>
				</div>
			</div>
		</Admin2>
	);
};

export default UploadBooksWizard;
